import { Component, OnInit, ViewChild, AfterViewInit, ElementRef} from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
//import { ElementRef } from '@angular/core/src/linker/element_ref';


export interface AlertModel {
  title: string;
  message: string;
  bold?: string;
}

@Component({
  selector: 'alert',
  template: `<div class="modal-dialog" style="border:none!important;width:380px!important;top:50px!important;">
                <div class="modal-content bgd-c" style="border:none!important;">
                   <div class="modal-header ">
                   <h4 class="modal-title">{{title || 'Alert!'}}</h4>
                     <button type="button" class="close" (click)="close()" >&times;</button>
                   </div>
                   <div class="modal-body" style="border:none!important;height:20px!important">
                     <p id="msg" innerHTML="{{message}}"></p>
                   </div>
                   <div class="modal-footer" style="border:none!important;">
                     <button type="button" class="btn btn-primary" (click)="close()" #setfocus>OK</button>
                   </div>
                </div>
             </div>`,
             styles: [`
   .bgd-c{background:#1D3F94!important;color:white!important}
   #msg{color: red!important;}   
 `]
})
export class AlertComponent extends DialogComponent<AlertModel, null> implements AlertModel {
  title: string;
  message: string;
  bold?: string;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    if (this.bold) {
    document.getElementById('msg').innerHTML = this.makeBold(this.message, this.bold);
    }
  }

  @ViewChild('setfocus', { static: true }) private elementref: ElementRef
  public ngAfterViewInit(): void {
    this.elementref.nativeElement.focus();
  }

  makeBold(message, bold?) {
    return message.replace(new RegExp('(' + bold + ')', 'gi'), '<b>$1</b>')
  }

  private inputFocused = false;
  moveFocus() {
      this.inputFocused = true;
      setTimeout(() => {this.inputFocused = false});
  }
}
